import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthenticateDomainService } from 'src/app/private/services/authenticate-domain.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-domain-authentication',
  templateUrl: './domain-authentication.component.html',
  styleUrls: ['./domain-authentication.component.scss']
})
export class DomainAuthenticationComponent {

  isInitLoading: boolean = true;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  loading: boolean = false;

  displayedColumns: string[] = [
    'domain',
    'spf_token',
    'dkim_tokens',
    'createdAt',
    'updatedAt',
    'default',
    'action'
  ];

  selectedDomain: any = null;
  btnLoading: boolean = false;
  private pendingRefreshDomainListAfterModalClose = false;


  constructor(
    private authenticateDomainService: AuthenticateDomainService,
    private localStorage: LocalStorageService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private tracker: TrackingService,
  ) {
    // Initialize any necessary services or variables here
  }

  ngOnInit() {
    this.isInitLoading = true;
    this.getAllClientDomain();
  }

  getAllClientDomain(type: string = 'init') {
    // Call the service to get all client domains
    const payload = {
      client_id: this.localStorage.getClientId()
    };

    this.loading = true;

    this.authenticateDomainService.getAllClientDomain(payload).subscribe({
      next: (response) => {
        this.dataSource = new MatTableDataSource(response) || new MatTableDataSource([]);
        // this.dataSource.data = [];
        console.log('Client domains fetched successfully:', this.dataSource.data);

        this.totalRows = this.dataSource.data.length;
        this.isInitLoading = false;
        this.loading = false;

        if (type == 'verify') {
          this.toastr.success('Domain verification status refreshed successfully');
        }
      },
      error: (error) => {
        console.error('Error fetching client domains:', error);
        this.isInitLoading = false;
        this.loading = false;
        this.toastr.error('Error fetching client domains');
      }
    });
  }


  onView(element: any, content: any) {
    this.selectedDomain = element;
    this.tracker.track("View", "Domain", `Viewed details for domain: ${element.domain}`);
    this.open(content);
  }

  onEdit(element: any) {
    console.log('Editing', element);
  }

  onDelete(element: any, content: any) {
    this.selectedDomain = element;
    this.modalService.open(content, {
      size: 'md', scrollable: true,
      centered: true
    });
  }

  onDomainCreatedInAddModal(): void {
    this.pendingRefreshDomainListAfterModalClose = true;
  }

  open(content: any) {
    const ref = this.modalService.open(content, {
      size: 'lg', scrollable: true,
      centered: true
    });
    void ref.result.finally(() => {
      if (this.pendingRefreshDomainListAfterModalClose) {
        this.getAllClientDomain();
        this.pendingRefreshDomainListAfterModalClose = false;
      }
    });
  }

  setDefaultDomain(domain: any) {
  if (!domain || domain.is_default) return;

  const payload = {
    id: domain.id,
    client_id: this.localStorage.getClientId(),
    is_default:true,
    domain:domain.domain
  };

  this.loading = true;

  this.authenticateDomainService
    .setDefaultDomain(payload)
    .subscribe({
      next: () => {
        // Reset all domains locally
        this.dataSource.data = this.dataSource.data.map(d => ({
          ...d,
          is_default: d.id === domain.id
        }));

        this.toastr.success('Default domain updated');
        this.loading = false;
      },
      error: () => {
        this.toastr.error('Failed to set default domain');
        this.loading = false;
      }
    });
}


  onRefresh(e: any) {
    console.log('Refreshing', e);
    const body = {
      "client_id": this.localStorage.getClientId(),
      "domain": e.domain,
    }
    this.loading = true;
    this.authenticateDomainService.domainVeriicationStatus(body).subscribe({
      next: () => {
        this.tracker.track("Refresh", "Domain Verification", `Refreshed verification status for domain: ${e.domain}`);
        this.getAllClientDomain('verify');
      },
      error: (e) => {
        console.log('Error refreshing domain verification status:', e);
        // if status code is 400, show error message
        if (e.status === 404) {
          this.toastr.error('Domain not found');
        } else {
          this.toastr.error('Error refreshing domain verification status');
        }
        this.loading = false;
      }
    });
  }


  handleDeleteDomain() {
    this.btnLoading = true;
    const payload = {
      client_id: this.localStorage.getClientId(),
      domain: this.selectedDomain.domain,
    };

    this.authenticateDomainService.deleteDomainAndEmail(payload).subscribe({
      next: (response) => {
        this.btnLoading = false;
        this.toastr.success('Domain deleted successfully');
        this.modalService.dismissAll();
        this.getAllClientDomain();

        // ✅ Tracking domain deletion
        const desc = `Deleted domain: ${this.selectedDomain.domain}`;
        this.tracker.track("Delete", "Domain", desc);
      },
      error: (error) => {
        this.btnLoading = false;
        console.error('Error deleting domain:', error);
        this.toastr.error('Failed to delete domain. Please try again.');
      }
    });
  }

  addEmailToDomain(element: any, content: any) {
    this.selectedDomain = element;
    this.modalService.open(content, {
      size: 'md', scrollable: true,
      centered: true
    });
  }

}
